<div class="main-div">
  <div class="selectDevices-section">
    <h2 class="selectDevices-heading">{{pageJson.heading}}</h2>
    <br>
    <p class="selectDevices-sub-heading">{{pageJson.description}}</p>

    <div class="selectDevices-info">
      <div class="selectDevices-greybox">
        <div class="container-box-sm">
          <div class="row">
            <h3 class="col-6 seachbox-heading">Find Devices</h3>
            <a href="javascript:void(0)" class="col-6 btn btn-link clear-btn pull-right" (keydown.enter)="clearAll()" (click)="clearAll()">Clear all</a>
          </div>
          <div class="row" >
            <div class="col-sm-12 col-md-4 inputContent">
              <label for="ctnNumber">Wireless user</label>
              <div class="input-field">
                  <input type="text"  (keyup)="checkPattern($event)" class="form-control field" id="ctnNumber" maxlength="10"/>
              </div>
              <div class="email-error-field" *ngIf="isctnNumberInvalid">
                <div class="text-danger">Invalid Data</div>
              </div>
            </div>
            
            <div class="col-sm-12 col-md-4 inputContent">
              <label for="imei">IMEI</label>
              <div class="input-field">
                  <input type="text" (keyup)="checkPattern($event)" class="form-control" id="imei" maxlength="15" />
              </div>
              <div class="email-error-field" *ngIf="isimeiNumberInvalid">
                <div class="text-danger">Invalid Data</div>
              </div>
            </div>
            
            <div class="col-sm-12 col-md-4 inputContent">
              <label for="deviceModel">Device Model</label>
              <div class="input-field">
                  <input type="text" (keyup)="checkPattern($event)" class="form-control" id="deviceModel"/>
              </div>
              <div class="email-error-field" *ngIf="isModelInvalid">
                <div class="text-danger">Invalid Data</div>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-sm-12 col-md-4 dropDown selectDropdown">
              <div class="dropDownInput">
                  <app-dropdown [placeholder]="'Select'" [placeholderAriaLabel]="'Status'" id="dropdownstatus" [options]="statusOptions"  [prePopulateValue]="defaultStatus" (selectEmit)="selectStatusOption($event)"></app-dropdown>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 dropdown-tm">
              <div class="dropDownInput">
                  <app-dropdown [placeholder]="'Select'" [placeholderAriaLabel]="'Group'" id="group" [options]="groupsOptions" [prePopulateValue]="defaultGroup" (selectEmit)="selectGroupOption($event)"></app-dropdown>
              </div>
            </div>
            <button class="col-sm-12 col-md-4 btn btn-secondary search-btn" tabindex="0" (click)="searchDevices($event)">Search</button>
          </div>
        </div>
      </div>
      <p *ngIf = "showNumberOfRowsSelected" >{{numberOfRowsSelected}} Selected of {{totalNumberOfRecords}}</p>
      <app-custom-grid-extended [gridOptions]='gridOptions' (onDataChange)="onRowClick($event)"></app-custom-grid-extended>

      <div id="button-section" class="row live">
        <div class="col-sm-12 col-md-12 text-right">
          <button class="btn btn-secondary pull-right continue-btn btn-width" type="submit" [disabled]="!showNumberOfRowsSelected" (click)="continue()">Continue</button>
          <a href="javascript:void(0)" class="btn btn-link btn-block btn-cancel btn-width" (click)="cancel()">Cancel</a>
        </div>
      </div>

    </div>

  </div>
</div>